'use strict';

const $ = require('jquery');
const isString = require('lodash/isString');

const SELECTOR = '.js-scroll-to';

function init() {
    let elements = $(SELECTOR);

    if (!elements.length) {
        return false;
    }

    $(document).on('click', SELECTOR, function (event) {
        // Let click event go no further
        event.stopPropagation();

        // Grab what was clicked
        const element = $(event.currentTarget);

        // Grab target to scroll to
        const target = element.attr('href') || element.data('target');

        // No need to continue if target is dud
        if (!isString(target) || !target.length) {
            return false;
        }

        // Grab a animation duration
        const duration = element.data('duration') || 1500;

        // Scroll!
        $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top - 100
        }, duration);
    });
}

module.exports = {
    init: init
};
